(function () {
  // Only initialise if the modal exists
  const modal = document.getElementById("SpecPdfModal");
  if (!modal) return;

  const frame = modal.querySelector(".SpecModal__frame");
  const titleEl = modal.querySelector(".SpecModal__title");
  const openNewTabLink = modal.querySelector(".SpecModal__open");
  const emailBtn = modal.querySelector(".SpecModal__email");

  // Close handlers (anything with [data-spec-close] closes the modal)
  const closeEls = modal.querySelectorAll("[data-spec-close]");
  closeEls.forEach((el) => el.addEventListener("click", () => closeModal()));

  // Store last clicked context
  let last = null;

  function openModal(specUrl, productTitle) {
    titleEl.textContent = productTitle ? `Spec sheet — ${productTitle}` : "Spec sheet";
    frame.src = specUrl;
    openNewTabLink.href = specUrl;
    modal.hidden = false;
  }

  function closeModal() {
    modal.hidden = true;
    // stop PDF rendering
    frame.src = "";
  }

  function openKlaviyoForm() {
    window._klOnsite = window._klOnsite || [];
    window._klOnsite.push(["openForm", "XL6v6i"]);
  }

  // Open PDF modal when clicking the product page button
  document.addEventListener("click", function (e) {
    const btn = e.target.closest(".SpecDownload");
    if (!btn) return;

    const specUrl = btn.dataset.specUrl || "";
    const productTitle = btn.dataset.productTitle || "";
    const productHandle = btn.dataset.productHandle || "";
    const productId = btn.dataset.productId || "";

    last = {
      specUrl,
      productTitle,
      productHandle,
      productId,
      pageUrl: window.location.href,
    };

    openModal(specUrl, productTitle);
  });

  // When user clicks "Email me this spec sheet", push context to Klaviyo, close PDF modal,
  // then open popup form (prevents popup sitting behind the PDF modal and being dismissed)
  emailBtn?.addEventListener("click", function () {
    // 1) Store the context on the Klaviyo profile BEFORE they submit email
    if (last) {
      window._learnq = window._learnq || [];
      window._learnq.push([
        "identify",
        {
          "Last Spec Sheet URL": last.specUrl,
          "Last Spec Product Title": last.productTitle,
          "Last Spec Product Handle": last.productHandle,
          "Last Spec Product ID": last.productId,
          "Last Spec Page URL": last.pageUrl,
        },
      ]);

      // Optional event tracking
      window._learnq.push([
        "track",
        "Spec Sheet Email Prompted",
        {
          "Spec Sheet URL": last.specUrl,
          "Product Title": last.productTitle,
          "Product Handle": last.productHandle,
          "Product ID": last.productId,
          "Page URL": last.pageUrl,
        },
      ]);
    }

    // 2) Close PDF modal first
    closeModal();

    // 3) Open Klaviyo popup shortly after
    setTimeout(() => {
      openKlaviyoForm();
    }, 150);
  });

  // Esc key closes modal
  document.addEventListener("keydown", function (e) {
    if (e.key === "Escape" && !modal.hidden) closeModal();
  });
})();